module.exports = __webpack_public_path__ + "static/media/credit-card.576721d0.svg";